import { CurrencyRateDetails } from 'further-types/lp/transaction';
import { round } from 'lodash';

export default function calculateLcyValue(
  tcyValue: number,
  currencyRate?: CurrencyRateDetails | null,
) {
  if (!tcyValue) {
    return 0;
  }
  if (!currencyRate) {
    return tcyValue;
  }

  return round(
    tcyValue / (currencyRate.overrideRate ?? currencyRate.fetchedRate ?? 1),
    2,
  );
}
